var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1 8.4a1.2 1.2 0 012.4 0v4.8a1.2 1.2 0 11-2.4 0V8.4zm3.2-.133v4.344a1.6 1.6 0 00.885 1.431l.04.02a3.2 3.2 0 001.43.338h4.332a1.6 1.6 0 001.57-1.286l.96-4.8A1.6 1.6 0 0012.948 6.4H10.1V3.2a1.6 1.6 0 00-1.6-1.6.8.8 0 00-.8.8v.534a3.2 3.2 0 01-.64 1.92L5.94 6.346a3.2 3.2 0 00-.64 1.92z",
    fill: "#41CBCE"
  })));
}
export default SvgThumbUp;